import React from 'react';
import GridFilter from '../../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../../Base/Enums/GridFilterItemType.enum';
import useFilters from '../../../../Base/Hooks/useFilters';
import { GRID_FILTER_KEYS } from '../../../../Base/Components/GridFilter/gridFilterKeys';

export interface PlannedQuestionnairesFilterValues {
	patientId?: string;
	questionnaireId?: string;
}

interface Props {
	onFilter: (values: PlannedQuestionnairesFilterValues) => void;
	patientId?: string;
	onReady?: () => void;
}

const PlannedQuestionnairesFilter: React.FC<Props> = ({
	onFilter,
	patientId,
	onReady,
}) => {
	const { checkEmptyString } = useFilters();
	const onFilterData = (values: any) => {
		const filter: PlannedQuestionnairesFilterValues = {
			patientId: checkEmptyString(values?.patient?.value),
			questionnaireId: values?.questionnaire
				? checkEmptyString(values.questionnaire.value)
				: undefined,
		};
		onFilter(filter);
	};

	return (
		<GridFilter
			defaultValues={{ patient: { value: patientId } }}
			onChange={onFilterData}
			onReady={onReady}
			storageKey={GRID_FILTER_KEYS.PLANNED_QUESTIONNAIRES_FILTER}>
			<GridFilterItem
				type={GridFilterItemType.PATIENT_ID}
				width={320}
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.QUESTIONNAIRE_ID}
				customPlaceholder='base.enterTheNameOfMonitoring'
				customLabel='base.monitoring'
				width={350}
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default PlannedQuestionnairesFilter;
